import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: spacing(16, '2%', 16, 34),
    gap: spacing(16),
  },
}))
